package com.essntl.core.waypoint.data

import com.essntl.config.EssntlConfig
import com.essntl.core.network.IO
import com.essntl.core.utils.error.BadRequestException
import com.essntl.core.waypoint.data.response.WaypointLogsResponse
import com.essntl.core.waypoint.data.response.WaypointResponse
import com.essntl.core.waypoint.domain.WaypointClient
import com.essntl.core.waypoint.domain.models.POServicesTemplate
import com.essntl.core.waypoint.domain.models.SimpleEmailTemplateData
import com.essntl.core.waypoint.domain.models.WaypointLogs
import io.ktor.client.HttpClient
import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.client.statement.*
import io.ktor.http.*
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext

internal class WaypointClientImpl(
    private val httpClient: HttpClient,
) : WaypointClient {
    override suspend fun sendEmail(template: SimpleEmailTemplateData): Result<String> =
        sendEmail {
            setBody(template)
        }

    override suspend fun sendEmail(template: POServicesTemplate): Result<String> =
        sendEmail {
            setBody(template)
        }

    override suspend fun waypointLogs(platformId: String): Result<List<WaypointLogs>> =
        withContext(Dispatchers.IO) {
            val response = httpClient.get("$BASE_URL/$platformId/events") {
                header(HttpHeaders.ContentType, ContentType.Application.Json)
                basicAuth(EssntlConfig.waypointUsername, EssntlConfig.waypointPassword)
            }

            if (response.status.isSuccess())
                Result.success(
                    response.body<WaypointLogsResponse>().data
                        .map { it.toModel() }
                        .filter { it.status != null },
                )
            else
                Result.failure(BadRequestException())
        }

    private suspend fun sendEmail(block: HttpRequestBuilder.() -> Unit): Result<String> =
        withContext(Dispatchers.IO) {
            val response = httpClient.post(BASE_URL) {
                header(HttpHeaders.ContentType, ContentType.Application.Json)
                basicAuth(EssntlConfig.waypointUsername, EssntlConfig.waypointPassword)
                block()
            }

            if (response.status.isSuccess())
                Result.success(response.body<WaypointResponse>().data.id)
            else
                Result.failure(BadRequestException())
        }

    companion object {
        private const val BASE_URL = "https://live.waypointapi.com/v1/email_messages"
    }
}
